import { Helmet } from "react-helmet";
import Navbar from "../components/universal/navbar";
import Header from "../components/general-dentistry/hero";
import WhatAndWhy from "../components/general-dentistry/what-and-why";
import Process from "../components/general-dentistry/process";
import AfterCare from "../components/general-dentistry/aftercare";
import CTA from "../components/general-dentistry/cta";
import Contact from "../components/universal/contact";
import Footer from "../components/universal/footer";
import QuestionsGD from "../components/general-dentistry/Question";

function Index() {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Service",
    name: "General Dentistry in Ilkley, West Yorkshire | Regent Dental",
    serviceType: "General Dentistry",
    url: "https://www.regent-dental.co.uk/general-dentistry",
    description:
      "At Regent Dental, we provide comprehensive general dentistry services, including routine checkups, fillings, crowns, and more to maintain your oral health.",
    provider: {
      "@type": "LocalBusiness",
      "@id": "http://regent-dental.co.uk/#localbusiness",
      name: "Regent Dental",
      image:
        "https://www.regent-dental.co.uk/static/media/3.4c51da854dc4cc666630.png",
      url: "http://regent-dental.co.uk/",
      telephone: "+01943 661331",
      openingHours: "Mo-Fr 09:00-17:00",
      priceRange: "$$",
      sameAs: [
        "https://www.facebook.com/people/Regent-Dental/61564954080373/",
        "https://www.instagram.com/regentdental_ilkley/",
        "https://g.co/kgs/EY9shTo",
      ],
      address: {
        "@type": "PostalAddress",
        streetAddress: "2A Regent Rd",
        addressLocality: "Ilkley",
        addressRegion: "England",
        postalCode: "LS29 9EA",
        addressCountry: {
          "@type": "Country",
          name: "UK",
        },
      },
      areaServed: [
        { "@type": "Place", name: "Ilkley" },
        { "@type": "Place", name: "Keighley" },
        { "@type": "Place", name: "Skipton" },
        { "@type": "Place", name: "Otley" },
        { "@type": "Place", name: "Silsden" },
      ],
    },
  };
  const schemaData2 = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "What does general dentistry cover at Regent Dental?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "General dentistry includes all the essential care to keep your teeth and gums healthy, such as check-ups, fillings, hygiene treatments, extractions, and advice on preventing future problems.",
        },
      },
      {
        "@type": "Question",
        name: "How often should I have a dental check-up?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Most people benefit from seeing us every six months, but we’ll recommend a schedule that’s tailored to your individual needs to keep your smile at its best.",
        },
      },
      {
        "@type": "Question",
        name: "What happens during a routine dental check-up?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "We’ll carefully examine your teeth, gums and mouth, check for signs of any problems. It’s all about keeping everything healthy and catching any issues early.",
        },
      },
      {
        "@type": "Question",
        name: "Do you offer dental hygiene appointments?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes, we do. Our lovely hygienist provides professional cleaning to remove plaque and tartar, helping to keep your mouth fresh, healthy, and sparkling.",
        },
      },
      {
        "@type": "Question",
        name: "Is fluoride important for my teeth?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Absolutely. Fluoride strengthens your enamel and helps to protect against decay. We may recommend fluoride treatments as part of your personalised dental care plan.",
        },
      },
      {
        "@type": "Question",
        name: "Which areas do you cover at Regent Dental?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "We’re proud to welcome patients from across Ilkley and the surrounding areas. Many of our lovely patients come to us from surrounding villages and towns like Silsden, Otley, Skipton, Keighley, Guiseley and beyond. Wherever you’re from, you can be sure of a warm welcome and exceptional care at Regent Dental!",
        },
      },
      {
        "@type": "Question",
        name: "What should I do if I have toothache or a broken tooth?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "If you’re in pain or have damaged a tooth, please contact us as soon as possible. We offer emergency appointments to get you out of discomfort quickly and plan any necessary treatment.",
        },
      },
      {
        "@type": "Question",
        name: "Are fillings still silver, or do you offer white fillings?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "We’re pleased to offer natural-looking white fillings that blend beautifully with your own teeth, so you can smile with confidence.",
        },
      },
      {
        "@type": "Question",
        name: "Will my treatment hurt?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "We pride ourselves on gentle dentistry. Whether it’s a simple filling or a more involved treatment, we’ll ensure you’re comfortable and relaxed throughout your visit.",
        },
      },
      {
        "@type": "Question",
        name: "Can you help with gum disease?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes. Early gum disease can often be reversed with professional cleaning and good home care, and we offer effective treatments to manage more advanced cases too.",
        },
      },
      {
        "@type": "Question",
        name: "How do I maintain healthy teeth and gums between visits?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Daily brushing, flossing, using fluoride toothpaste, a healthy diet, and regular visits to our dental team are the best ways to keep your smile strong and healthy for life.",
        },
      },
    ],
  };

  return (
    <div>
      <Helmet>
        <title>
          General Dentistry in Ilkley, West Yorkshire | Regent Dental{" "}
        </title>
        <meta
          name="description"
          content="Maintain healthy teeth with general dentistry in Ilkley. Regent Dental offers check-ups, fillings, hygiene treatments, and preventative dental care."
        />
        <link
          rel="canonical"
          href="https://www.regent-dental.co.uk/general-dentistry"
        />
        <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
        <script type="application/ld+json">
          {JSON.stringify(schemaData2)}
        </script>
      </Helmet>
      <Navbar />
      <Header />
      <WhatAndWhy />
      <Process />
      <AfterCare />
      <QuestionsGD />
      <CTA />
      <Contact />
      <Footer />
    </div>
  );
}

export default Index;
